<template>
<!-- footer -->
<div class="clearfix" style="width: 100%"></div><!-- stop content from flowing behind footer -->
<footer id="footer_container">
  <div class="container">
    <p class="text-muted" style="margin: 20px; text-align: center;">
    <small>
    Copyright &copy; TritonX Inc. All rights reserved.
    </small>
    </p>
  </div>
</footer>    
</template>
<script setup>
</script>